export default __webpack_public_path__ + "static/media/logo.922eaf14.png";